<fieldset [formGroup]="group">
  <legend>{{ TITLE + "CUSTOMER_SEGMENT" | translate }}:</legend>
  <div
    class="bools in-one-column w-100"
    [ngClass]="{ error: hasError && group.touched }"
  >
    <ng-template
      let-control="control"
      let-title="title"
      let-disabled="disabled"
      let-retailer="retailer"
      #boolField
    >
      <mat-form-field>
        <app-easy-checkbox
          [formControlName]="control"
          [label]="TITLE + title | translate"
          [matTooltip]="
            disabled
              ? ('PRODUCTS.HINT.CUSTOMER_SEGMENT_CHANGE' | translate)
              : ''
          "
          (ngModelChange)="onValueChange($event, control)"
        ></app-easy-checkbox>
      </mat-form-field>
    </ng-template>
    <ng-template
      let-control="control"
      let-title="title"
      let-disabled="disabled"
      let-retailer="retailer"
      #retailerBoolField
    >
      <div class="ms-5" formGroupName="retailers">
        <mat-form-field>
          <app-easy-checkbox
            [formControlName]="control"
            [label]="TITLE + title | translate"
            [matTooltip]="
              disabled
                ? ('PRODUCTS.HINT.CUSTOMER_SEGMENT_CHANGE' | translate)
                : ''
            "
            (ngModelChange)="onValueChange($event, control)"
          ></app-easy-checkbox>
        </mat-form-field>
      </div>
    </ng-template>

    <ng-container
      *ngTemplateOutlet="
        boolField;
        context: {
          control: 'manufacturersAllowed',
          title: 'MANUFACTURERS_ALLOWED',
          disabled: !getCtrl('manufacturersAllowedModifiable')?.value
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        boolField;
        context: {
          control: 'importersAllowed',
          title: 'IMPORTERS_ALLOWED',
          disabled: !getCtrl('importersAllowedModifiable')?.value
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        boolField;
        context: {
          control: 'wholesalersAllowed',
          title: 'WHOLESALERS_ALLOWED',
          disabled: !getCtrl('wholesalersAllowedModifiable')?.value
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        boolField;
        context: {
          control: 'retailersAllowed',
          title: 'RETAILERS_ALLOWED',
          disabled: !getCtrl('retailersAllowedModifiable')?.value
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        retailerBoolField;
        context: {
          control: 'hotelsAllowed',
          title: 'HOTELS_ALLOWED',
          disabled: !getCtrl('retailers.hotelsAllowedModifiable')?.value,
          retailer: true
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        retailerBoolField;
        context: {
          control: 'restaurantsAllowed',
          title: 'RESTAURANTS_ALLOWED',
          disabled: !getCtrl('retailers.restaurantsAllowedModifiable')?.value,
          retailer: true
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        retailerBoolField;
        context: {
          control: 'cafesAllowed',
          title: 'CAFES_ALLOWED',
          disabled: !getCtrl('retailers.cafesAllowedModifiable')?.value,
          retailer: true
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        retailerBoolField;
        context: {
          control: 'retailChainsAllowed',
          title: 'RETAIL_CHAINS_ALLOWED',
          disabled: !getCtrl('retailers.retailChainsAllowedModifiable')?.value,
          retailer: true
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        retailerBoolField;
        context: {
          control: 'trafiksAllowed',
          title: 'TRAFIKS_ALLOWED',
          disabled: !getCtrl('retailers.trafiksAllowedModifiable')?.value,
          retailer: true
        }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        retailerBoolField;
        context: {
          control: 'otherRetailersAllowed',
          title: 'OTHER_RETAILERS__ALLOWED',
          disabled: !getCtrl('retailers.otherRetailersAllowedModifiable')
            ?.value,
          retailer: true
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        boolField;
        context: {
          control: 'endConsumersAllowed',
          title: 'END_CONSUMERS_ALLOWED',
          disabled: !getCtrl('endConsumersAllowedModifiable')?.value
        }
      "
    ></ng-container>
  </div>

  <p *ngIf="hasError" class="warn-color">
    {{ HINT + "CUSTOMER_SEGMENT" | translate }}
  </p>
</fieldset>
